import { size, map, get } from 'lodash';
import XLSX from 'xlsx';
import { alphabet } from 'app-constants/common';
import XlsxPopulate from 'xlsx-populate';
import { saveAs } from 'file-saver';
import { roundNumber } from './format';
import moment from 'moment';
import { getMessage } from './divisons';

const mapper = {
  ['MÃ NGOÀI BAO'.toUpperCase().trim()]: 'packing_list_code',
  ['GHI CHÚ BAO'.toUpperCase().trim()]: 'packing_list_note',
  ['TÊN HÀNG TIẾNG VIỆT CỦA TỪNG KiỆN'.toUpperCase().trim()]: 'item_name',
  ['TÊN HÀNG TIẾNG TRUNG CỦA TỪNG KiỆN'.toUpperCase().trim()]: 'item_name_cn',
  ['GIÁ TiỀN'.toUpperCase().trim()]: 'price',
  ['Mã vận đơn TQ'.toUpperCase().trim()]: 'tracking_code',
  ['Mã vận đơn VN'.toUpperCase().trim()]: 'tracking_code_alt',
  ['COD (RMB)'.toUpperCase().trim()]: 'cod_rmb',
  ['COD (VNĐ)'.toUpperCase().trim()]: 'cod_vnd',
  ['SỐ LƯỢNG'.toUpperCase().trim()]: 'quantity',
  ['SỐ CÂN'.toUpperCase().trim()]: 'weight',
  ['ĐỊA CHỈ KHO TQ (latinh)'.toUpperCase().trim()]: 'warehouse_addr', // Tattie,
  ['ĐỊA CHỈ CHI TiẾT KHO TQ (latinh)'.toUpperCase().trim()]:
    'warehouse_detail_addr', // China Room 302, building 11, No. 500, donghuzhuang, Tancheng Town, Pingtan County, Fuzhou City, Fujian Province
  ['TÊN KHÁCH VN'.toUpperCase().trim()]: 'to_name',
  ['ĐỊA CHỈ KHÁCH HÀNG'.toUpperCase().trim()]: 'to_add',
  ['QuẬN/ HUYỆN'.toUpperCase().trim()]: 'to_district_name',
  ['TỈNH / THÀNH PHỐ'.toUpperCase().trim()]: 'to_province_name',
  ['TÊN NGƯỜI NHẬN'.toUpperCase().trim()]: 'to_name',
  ['SỐ ĐiỆN THOẠI'.toUpperCase().trim()]: 'to_phone',
  ['KHÁCH HÀNG'.toUpperCase().trim()]: 'customer_code',
};

const mapperPL = {
  ['MÃ NGOÀI BAO'.toUpperCase().trim()]: 'packing_list_code',
  ['GHI CHÚ BAO'.toUpperCase().trim()]: 'packing_list_note',
  ['TÊN HÀNG TIẾNG VIỆT CỦA TỪNG KiỆN'.toUpperCase().trim()]: 'item_name',
  ['TÊN HÀNG TIẾNG TRUNG CỦA TỪNG KiỆN'.toUpperCase().trim()]: 'item_name_cn',
  ['GIÁ TiỀN'.toUpperCase().trim()]: 'price',
  ['Mã vận đơn'.toUpperCase().trim()]: 'tracking_code',
  ['Mã vận đơn TQ'.toUpperCase().trim()]: 'tracking_code',
  ['Mã vận đơn VN'.toUpperCase().trim()]: 'tracking_code_alt',
  ['MÃ KHÁCH'.toUpperCase().trim()]: 'customer_code',
  ['COD (RMB)'.toUpperCase().trim()]: 'parcel_cod',
  ['COD (VNĐ)'.toUpperCase().trim()]: 'cod_vnd',
  ['SỐ LƯỢNG'.toUpperCase().trim()]: 'quantity',
  ['SỐ CÂN'.toUpperCase().trim()]: 'weight',
  ['TÊN KHÁCH'.toUpperCase().trim()]: 'customer_name',
  ['ĐỊA CHỈ KHÁCH HÀNG'.toUpperCase().trim()]: 'customer_addr',
  ['QUẬN/ HUYỆN'.toUpperCase().trim()]: 'customer_district',
  ['TỈNH / THÀNH PHỐ'.toUpperCase().trim()]: 'customer_province',
  ['SỐ ĐIỆN THOẠI'.toUpperCase().trim()]: 'customer_phone',
};

const mapperDetailStatement = {
  ['Mã vận đơn'.toUpperCase().trim()]: 'tracking_code',
  ['Loại chi phí'.toUpperCase().trim()]: 'charge_type_t',
  ['Loại hình'.toUpperCase().trim()]: 'charge_type_desc_t',
  ['SL'.toUpperCase().trim()]: 'amount',
  ['ĐVT'.toUpperCase().trim()]: 'unit',
  ['Đơn giá'.toUpperCase().trim()]: 'price_per_unit',
  ['Thành tiền'.toUpperCase().trim()]: 'total',
  ['Đối tác xử lý	'.toUpperCase().trim()]: 'handled_by',
  ['Người cập nhật'.toUpperCase().trim()]: 'updated_by',
  ['Ngày cập nhật'.toUpperCase().trim()]: 'updated_at',
};

const mapperOutbound = {
  ['STT'.toUpperCase().trim()]: 'index',
  ['Mã vận đơn / Mã tải'.toUpperCase().trim()]: 'code',
  ['Khách hàng'.toUpperCase().trim()]: 'customer',
  ['Khối lượng (KG)'.toUpperCase().trim()]: 'weight_kg',
  ['Ghi chú'.toUpperCase().trim()]: 'note',
  ['Kho hàng'.toUpperCase().trim()]: 'warehouse',
  ['Thời gian xuất kho'.toUpperCase().trim()]: 'date_create',
  ['Người nhận'.toUpperCase().trim()]: 'receiver_name',
  ['Số điện thoại'.toUpperCase().trim()]: 'receiver_phone',
};

export const handleDownloadMNFFile = (
  type,
  data = [],
  fileName: number | string = Date.now()
) => {
  const req = new XMLHttpRequest();
  const url = `${window.location.origin}/assets/excels/MNF-template-${type}.xlsx`;
  req.open('GET', url, true);
  req.responseType = 'arraybuffer';
  req.onreadystatechange = () => {
    if (req.readyState === 4) {
      if (req.status === 200) {
        XlsxPopulate.fromDataAsync(req.response).then((workbook) => {
          handleDataExport(workbook, data, type).then(() => {
            workbook.outputAsync().then((blob) => {
              saveAs(blob, 'MNF_' + fileName + '.xlsx');
            });
          });
        });
      }
    }
  };
  req.send();
};

export const handleExportOutbound = async (
  data,
  fileName: number | string = Date.now()
) => {
  const req = new XMLHttpRequest();
  const url = `${window.location.origin}/assets/excels/VNConfirm-Template.xlsx`;
  req.open('GET', url, true);
  req.responseType = 'arraybuffer';
  req.onreadystatechange = () => {
    if (req.readyState === 4) {
      if (req.status === 200) {
        return XlsxPopulate.fromDataAsync(req.response).then((workbook) => {
          // sheet 1 - detail mapperOutbound
          // sheet 2 - print

          workbook.sheet(0).cell(`C4`).value(data.warehouse);
          workbook.sheet(0).cell(`C6`).value(data.date_create);
          workbook.sheet(0).cell(`E4`).value(data.receiver_name);
          workbook.sheet(0).cell(`E5`).value(data.receiver_phone);
          workbook.sheet(0).cell(`E6`).value(data.note);

          let row = 10;
          for (let i = 0; i < size(data.dataList); i++) {
            row += 1;
            workbook
              .sheet(0)
              .cell(`A${row}`)
              .value(i + 1);
            workbook
              .sheet(0)
              .cell(`B${row}`)
              .value(get(data, `dataList.${i}.code`));
            workbook
              .sheet(0)
              .cell(`C${row}`)
              .value(get(data, `dataList.${i}.customer`));
            workbook
              .sheet(0)
              .cell(`D${row}`)
              .value(get(data, `dataList.${i}.weight_kg`));
            workbook
              .sheet(0)
              .cell(`E${row}`)
              .value(get(data, `dataList.${i}.note`));
          }

          // create total
          workbook
            .sheet(0)
            .range(`C${row + 1}:C${row + 1}`)
            .merged(true)
            .value('Tổng:')
            .style({ bold: true, horizontalAlignment: 'center' });

          // create footer
          workbook
            .sheet(0)
            .range(`A${row + 5}:C${row + 5}`)
            .merged(true)
            .value('NGƯỜI NHẬN HÀNG')
            .style({ bold: true, horizontalAlignment: 'center' });
          workbook
            .sheet(0)
            .range(`A${row + 6}:C${row + 6}`)
            .merged(true)
            .value('(Ký và ghi rõ họ tên)')
            .style({ horizontalAlignment: 'center' });
          // create footer
          workbook
            .sheet(0)
            .range(`D${row + 5}:E${row + 5}`)
            .merged(true)
            .value('ĐẠI DIỆN KHO HÀNG')
            .style({ bold: true, horizontalAlignment: 'center' });
          workbook
            .sheet(0)
            .range(`D${row + 6}:E${row + 6}`)
            .merged(true)
            .value('(Ký và ghi rõ họ tên)')
            .style({ horizontalAlignment: 'center' });

          return workbook.outputAsync().then((blob) => {
            saveAs(blob, fileName + '.xlsx');
          });
        });
      }
    }
  };
  req.send();
};

export const handleDownloadReportExcel = async (
  type,
  data = [],
  fileName: number | string = Date.now()
) => {
  const req = new XMLHttpRequest();
  const url = `${window.location.origin}/assets/excels/Report-template-${type}.xlsx`;
  req.open('GET', url, true);
  req.responseType = 'arraybuffer';
  req.onreadystatechange = () => {
    if (req.readyState === 4) {
      if (req.status === 200) {
        return XlsxPopulate.fromDataAsync(req.response).then((workbook) => {
          return handleDataExportReport(workbook, data, type).then(() => {
            return workbook.outputAsync().then((blob) => {
              saveAs(blob, fileName + '.xlsx');
            });
          });
        });
      }
    }
  };
  req.send();
};

export const handleDataExportReport = async (workbook, data, type) => {
  if (size(data) > 0) {
    const transData = data;
    const values = workbook.sheet(0).usedRange().value();
    const headers = values[0];
    switch (type) {
      case 'DETAIL_STATEMENT': {
        for (let i = 0; i < size(transData); i++) {
          Object.values(headers).map((h: any, hi) => {
            const _h = String(h).toUpperCase().trim();
            let v = transData[i][mapperDetailStatement[_h]];
            if (mapperDetailStatement[_h] === 'updated_at') {
              v = moment(v).format(getMessage('pages.common.format.date_time'));
            }
            if (mapperDetailStatement[_h] === 'price_per_unit') {
              v = roundNumber((v || 0) / 1000, 2);
            }
            if (mapperDetailStatement[_h] === 'price_per_unit') {
              v = roundNumber((v || 0) / 1000, 2);
            }
            workbook
              .sheet(0)
              .cell(`${alphabet[hi]}${i + 2}`)
              .value(v);
            return 0;
          });
        }
        break;
      }
      default: {
        for (let i = 0; i < size(transData); i++) {
          Object.values(headers).map((h: any, hi) => {
            const _h = String(h).toUpperCase().trim();
            let v = transData[i][mapperPL[_h]];
            if (mapperPL[_h] === 'weight') {
              v = roundNumber((v || 0) / 1000, 2);
            }
            workbook
              .sheet(0)
              .cell(`${alphabet[hi]}${i + 2}`)
              .value(v);
            return 0;
          });
        }
      }
    }
  }
};

export const handleDataExport = async (workbook, data, type) => {
  console.log('export', data);
  if (size(data) > 0) {
    const transData = [];
    const values = workbook.sheet(0).usedRange().value();
    const headers = values[0];
    switch (type) {
      case 'VN': {
        map(data, (row) => {
          // const lineNumber = size(String(row.item_name).split('\n'));
          for (let lineNo = 0; lineNo < 1; lineNo++) {
            const lineText = String(row.item_name).split('\n')[lineNo];
            const qtyReg = String(lineText).trim().match(/^\d+/);
            const quantity = qtyReg ? Number(qtyReg[0]) || 1 : 1;
            const item_name = String(lineText)
              .trim()
              .replace(/^\d+/, '')
              .trim();
            if (!row.tracking_code_alt) {
              row.tracking_code_alt = row.tracking_code;
            }
            transData.push({ ...row, item_name, quantity });
          }
        });
        break;
      }
      case 'CN': {
        map(data, (row) => {
          const lineNumber = size(String(row.item_name_cn).split('\n'));
          for (let lineNo = 0; lineNo < lineNumber; lineNo++) {
            const lineText = String(row.item_name_cn).split('\n')[lineNo];
            const qtyReg = String(lineText).trim().match(/^\d+/);
            const quantity = qtyReg ? Number(qtyReg[0]) || 1 : 1;
            const item_name_cn = String(lineText)
              .trim()
              .replace(/^\d+/, '')
              .trim();

            const lineText2 = String(row.item_name).split('\n')[lineNo];
            const item_name = String(lineText2)
              .trim()
              .replace(/^\d+/, '')
              .trim();

            transData.push({
              ...row,
              item_name_cn,
              quantity,
              packing_list_code: row.packing_list_code,
              item_name,
            });
          }
        });
        break;
      }
    }
    for (let i = 0; i < size(transData); i++) {
      Object.values(headers).map((h: any, hi) => {
        const _h = String(h).toUpperCase().split('\n')[0].trim();
        let v = transData[i][mapper[_h]];
        switch (mapper[h]) {
          case 'weight': {
            v = roundNumber((v || 0) / 1000, 2);
            break;
          }
          case 'quantity': {
            v = v ? v : 1;
            break;
          }
          case 'to_add': {
            v = `${v}, ${transData[i]['to_district_name']}, ${transData[i]['to_province_name']}`;
            break;
          }
          case 'item_name_cn':
          case 'item_name': {
            v = String(v).replace(/.+? x/g, '').trim();
            break;
          }
          case 'warehouse_addr':
          case 'warehouse_detail_addr': {
            v = 'Logistics Sorting Hub, Shenzhen Tang Tou Industrial Park';
          }
        }

        workbook
          .sheet(0)
          .cell(`${alphabet[hi]}${i + 2}`)
          .value(v);
        return 0;
      });
    }
  }
};

export function exportXlsx(columns, params) {
  let { data, detail, filename, ws_name } = params;

  filename = filename ? filename : 'tai-ve.xlsx';

  // create new workbook
  const wb = XLSX.utils.book_new();

  if (data && Array.isArray(data)) {
    const headers = columns
      .filter((col) => !col.ignore_export)
      .map((col) => col.name || col.title);
    const dataRows = data.map((record) => {
      return columns
        .filter((col) => !col.ignore_export)
        .map((col) => record[col.key || col.dataIndex]);
    });

    const sheetData = [headers, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    /* add worksheet to workbook */
    ws_name = ws_name ? ws_name : 'KET_QUA';
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
  }

  /* add detail worksheet to workbook */
  if (detail && Array.isArray(detail)) {
    const headers = Object.keys(detail[0]);
    const dataRows = detail.map((record) => headers.map((col) => record[col]));
    const sheetData = [headers, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    /* add worksheet to workbook */
    const ws_name = 'CHI_TIET';
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
  }

  /* write workbook */

  XLSX.writeFile(wb, filename);
}
